import {cDisplay} from '../creator/cDisplay'
import { speechBubble } from '../creator/cDisplayObjects/speechBubble';
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { getStr } from "../creator/utils/simpleLocalisation";


export class sceneBusDisplay extends cDisplay {

  private ccList: number[]
  private result: number[]
  private mData: any;

  init(){
    super.init()

    this.ccList = Phaser.Math.RND.shuffle([1,2,3,4,5,6]);
    this.result = [];

    (this.scene as cScene).ev.addListener('action',(command,options)=>{
      console.log('BUS',options)

      let person = (this.scene as cScene).getState('person');
      switch (options.command ){

        case 'show_person':
          let c:Phaser.GameObjects.Container = this.getByName('holder_person');
          let list:any[] = c.getAll();
          list.map(el=>el.visible = 0)
          let r = this.getByName('person_'+options.options )
          if (r) r.visible = true
          break;

        case 'evaluate_answer':          
          let answer = (this.scene as cScene).getState('answer')
          let answerdata = this.mData['person_'+person];

          if (String(answer) == String(answerdata.answer)){
            this.result.push(1);
            (this.scene as cScene).triggerSceneEvent('correct',{
              person:person,
              info: getStr(answerdata.correct),
              title: getStr(answerdata.correct_title)
            });            
          }else{
            this.result.push(0);
            (this.scene as cScene).triggerSceneEvent('wrong',{
              person:person,
              info: getStr(answerdata.wrong),
              title: getStr(answerdata.wrong_title)
            });            
          }
          break;

        case 'show_bubble':
          let msg = this.mData['person_'+person]
          var bData = {
            ofs:'550x450',
            value: msg.bubble,
            stalk: 80,
            stalkid:'on_rightside',
            type:'normal',
            btn:false
          }

          var bb = new speechBubble(this.scene as cScene,bData as any, ()=>{ });
          bb.name = 'speechbubble';
          this.scene.add.existing(bb)
          break;

        case 'next_person':
          if (this.ccList.length == 0){
            (this.scene as cScene).triggerSceneEvent('next',{index:7})
//            (this.scene as cScene).triggerSceneEvent('completed')  
            return
          }
          var n = this.ccList.pop();
          (this.scene as cScene).triggerSceneEvent('next',{index:n})
          break;

        case 'trigger_game_result':
          var correctCount = this.result.filter((e)=>e==1);
          (this.scene as cScene).triggerSceneEvent('result',{score:['bus',correctCount.length,6].join(':')})
          break;
      }
    })    

  }

  buildScene(){
    super.buildScene();
    let ref = this.getByName('holder_person');
    this.mData = (ref as cContainer).modules.data._extraData;

  }
  

}
